import React from "react"
import PropTypes from "prop-types"
import { toMoney } from "utils/string_utils"
import "./summary-box.scss"

const SummaryBox = ({ planName, deviceSummary, planSummary, totalCosts }) => {
  return (
    <div className="summary-box">
      <div className="summary-box--device">
        <div className="summary-box--device--image">
          <img src={deviceSummary.img} alt={deviceSummary.text} width="80px" />
        </div>
        <div className="summary-box--device--details">
          <h1>{planName}</h1>
          {planSummary.benefitsText &&
            planSummary.benefitsText.map((benefit, i) => (
              <div key={i}>
                <span dangerouslySetInnerHTML={{ __html: benefit }} />
              </div>
            ))}
        </div>
      </div>
      <div className="summary-box--pay">
        <div className="summary-box--pay--header">Pay upfront</div>
        <div className="summary-box--pay--amount">
          {toMoney(totalCosts.upfront || 0)}
        </div>
      </div>
      <div className="summary-box--pay">
        <div className="summary-box--pay--header">Pay monthly</div>
        <div className="summary-box--pay--amount">
          {toMoney(totalCosts.monthly || 0)}
        </div>
      </div>
    </div>
  )
}

SummaryBox.propTypes = {
  planName: PropTypes.string.isRequired,
  deviceSummary: PropTypes.object.isRequired,
  planSummary: PropTypes.object.isRequired,
  totalCosts: PropTypes.object.isRequired
}

export default SummaryBox
